export const DEFAULT_TENANT_BRAND_COLOR = '#ef4444'

export function isHexColor(value: string): boolean {
  return /^#[0-9a-f]{6}$/i.test(value)
}

export function normalizeHexColor(value: string): string {
  const trimmed = value.trim()
  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`
  return withHash.toLowerCase()
}

function relativeLuminance(hexColor: string): number {
  const channels = [1, 3, 5].map((offset) =>
    Number.parseInt(hexColor.slice(offset, offset + 2), 16)
  )
  const [red, green, blue] = channels.map((channel) => {
    const value = channel / 255
    return value <= 0.04045
      ? value / 12.92
      : Math.pow((value + 0.055) / 1.055, 2.4)
  })
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

function contrastRatio(first: number, second: number): number {
  const lighter = Math.max(first, second)
  const darker = Math.min(first, second)
  return (lighter + 0.05) / (darker + 0.05)
}

export function readableBrandForeground(hexColor: string): string {
  const luminance = relativeLuminance(hexColor)
  const dark = relativeLuminance('#111827')
  const white = 1
  return contrastRatio(luminance, dark) >= contrastRatio(luminance, white)
    ? '#111827'
    : '#ffffff'
}

export function brandContrast(hexColor: string): {
  foreground: string
  ratio: number
  passesAa: boolean
} {
  const foreground = readableBrandForeground(hexColor)
  const ratio = contrastRatio(
    relativeLuminance(hexColor),
    relativeLuminance(foreground)
  )
  return { foreground, ratio, passesAa: ratio >= 4.5 }
}
